import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CreateEventAction, CreateEventFulfilledAction } from '../../domains/createEvent/actions.types';

import { CreateEventRequests } from './types';

export type { CreateEventAction };

const initialState: CreateEventRequests = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CreateEventRequests, CreateEventAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CREATE_EVENT.PENDING':
      return moveToPending(state, [action.payload.communityId]);
    case 'CREATE_EVENT.FULFILLED':
      return stateWithFulfilled(state, action);
    case 'CREATE_EVENT.REJECTED':
      return moveToRejected(state, [action.payload.communityId], action.payload.error);
    case 'CREATE_EVENT.RESET_STATUS':
      return initialState;
    default:
      return state;
  }
};

const stateWithFulfilled = (state: CreateEventRequests, action: CreateEventFulfilledAction) => {
  const broadcastId = Object.keys(action.payload.entities.liveEvents)[0];

  return moveToFulfilled(state, { [action.payload.communityId]: { id: broadcastId } });
};

export default reducer;
